var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFabric2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6284_26884)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15685 6.34315L1.38909 8.11091L9.16726 15.8891L10.935 14.1213L3.15685 6.34315ZM17.6525 3.16117L15.8848 1.3934L8.1066 9.17157L9.87437 10.9393L17.6525 3.16117ZM3.15685 17.6569L1.38909 15.8891L4.21751 13.0607L5.98528 14.8284L3.15685 17.6569ZM8.1066 1.3934L6.33883 3.16117L9.16726 5.98959L10.935 4.22183L8.1066 1.3934ZM13.0563 9.87868L14.8241 8.11091L22.6023 15.8891L20.8345 17.6569L13.0563 9.87868ZM15.8848 14.8284L14.117 13.0607L6.33883 20.8388L8.1066 22.6066L15.8848 14.8284ZM19.7739 10.9393L18.0061 9.17157L20.8345 6.34315L22.6023 8.11091L19.7739 10.9393ZM14.8241 18.0104L13.0563 19.7782L15.8848 22.6066L17.6525 20.8388L14.8241 18.0104Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6284_26884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFabric2);
export default __webpack_public_path__ + "static/media/icon-fabric2.77a758595b5ce7050c990e6805772d7b.svg";
export { ForwardRef as ReactComponent };